import { useState } from 'react';
import { Play, FileText, ClipboardList } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ReportViewDialog } from '@/components/reports/ReportViewDialog';

// ============================================================================
// PollTestActions — действия страницы теста (FilledPollsPage), единая точка:
// «Отчёт» (если у методики есть отчёт — поставка psy даёт отчётам имя = синониму
// методики), «Создать протокол» (внешняя методика без вопросов — ручной ввод
// результата) и «Пройти». Нет отчёта / нет вопросов — соответствующей кнопки
// НЕТ (не заглушка). Отчёт открывается В ТЕКУЩЕЙ ОБОЛОЧКЕ (ReportViewDialog —
// Ф0-хотфикс: раньше уводил в /designer/reports/preview со сменой оболочки).
// ============================================================================

export function PollTestActions({ qState, questionsCount, psyMode, reportId, onFill, onManual }: {
    qState: 'loading' | 'ready' | 'error';
    questionsCount: number;
    psyMode: boolean;
    reportId: string;
    onFill: () => void;
    onManual: () => void;
}) {
    const [reportOpen, setReportOpen] = useState(false);
    const canFill = qState === 'ready' && questionsCount > 0;
    const showManual = qState === 'ready' && questionsCount === 0;
    const fillTitle = qState !== 'ready'
        ? 'Прохождение недоступно — вопросы методики не загружены (пояснение ниже)'
        : questionsCount === 0
            ? 'Внешняя методика: контента нет — результат вносится вручную («Создать протокол»)'
            : psyMode ? 'Пройти методику (сначала — выбор клиента)' : 'Пройти методику';
    return (
        <div className="ml-auto flex items-center gap-1">
            {reportId && (
                <Button size="sm" variant="outline" className="h-7 text-[11px]" title="Открыть отчёт по методике"
                    onClick={() => setReportOpen(true)}>
                    <FileText className="h-3 w-3 mr-1" /> Отчёт
                </Button>
            )}
            {showManual && (
                <Button size="sm" variant="outline" className="h-7 text-[11px]" title="Ручной протокол внешней (авторской) методики"
                    onClick={onManual}>
                    <ClipboardList className="h-3 w-3 mr-1" /> Создать протокол
                </Button>
            )}
            <Button size="sm" className="h-7 text-[11px]" onClick={onFill} disabled={!canFill} title={fillTitle}>
                <Play className="h-3 w-3 mr-1" /> Пройти
            </Button>
            {reportOpen && (
                <ReportViewDialog reportId={reportId} title="Отчёт по методике" onClose={() => setReportOpen(false)} />
            )}
        </div>
    );
}
